import { PaymentResultRequest } from './types';

/**
 * Čita URL parametre i kreira PaymentResultRequest objekt
 * @param searchParams - URL search parameters
 * @returns PaymentResultRequest objekt
 */
export const parsePaymentResultFromUrl = (searchParams: URLSearchParams): PaymentResultRequest => {
  console.log('searchParams:', searchParams.toString());
  
  const result = {
    status_transakcije: searchParams.get('status_transakcije') || '',
    jezik: searchParams.get('jezik') || '',
    kod_odgovora: searchParams.get('kod_odgovora') 
      ? decodeURIComponent(searchParams.get('kod_odgovora')!) 
      : '',
    id_web_trgovina: searchParams.get('id_web_trgovina') 
      ? parseInt(searchParams.get('id_web_trgovina')!) 
      : 0,
    id_kosarica: searchParams.get('id_kosarica') || '',
    hash: searchParams.get('hash') || ''
  };

  console.log('parsePaymentResultFromUrl result:', result);
  
  return result;
   
};

export const resolveCartContent = (
  value: string | undefined,
  t: (key: any) => string
): string => {
  if (!value) return '';
  if (value === 'Novčane kazne') return t('cartFines');
  if (value === 'Troškovi postupka') return t('cartFees');
  return value;
};